import React from 'react';

import {useTranslation} from 'react-i18next';

import {ContentContainerProps} from '..';
import {Spinner} from '../../Spinner';

import {CenterContainer, Content, Wrapper, ErrorHeading} from './styled';

export const ContentContainer = (props: ContentContainerProps) => {
    const {status, children, className, noPaddings} = props;
    const {t} = useTranslation();
    return (
        <Wrapper className={className} noPaddings={noPaddings}>
            {status === 'loading' ? (
                <CenterContainer>
                    <Spinner />
                </CenterContainer>
            ) : status === 'error' ? (
                <CenterContainer>
                    <div>
                        <ErrorHeading>{t('errors.occurred')}</ErrorHeading>
                        <p>{t('errors.tryMessage')}</p>
                    </div>
                </CenterContainer>
            ) : (
                <Content>{children}</Content>
            )}
        </Wrapper>
    );
};
